export const removeFloatingPoint = (num) => {
	return parseFloat(num.toFixed(2));
}